import { Box, Button, Card, Flex, Grid, GridItem, Heading,Select, Text,Input, Image, UnorderedList, ListItem} from '@chakra-ui/react';
import { BsPlusLg as PlusIcon } from "react-icons/bs";
import { IoEyeOutline as EyeIcon } from "react-icons/io5";
import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
import {TopLink} from '../';
import apiCall from '../../../../utils/apiCall';
import { Formik,Form,Field } from "formik";
import { atom, useAtom } from 'jotai';
import * as Yup from 'yup';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
// import { GrCloudUpload as UpIcon} from "react-icons/gr";
import { useState,useRef, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
import apiCallFormData from '../../../../utils/apiFormDataCall';
import ReactPaginate from 'react-paginate';
import styled from '@emotion/styled';
import { Loader } from '../../../../customs';


const src=`/public-assets/upload_icon.png`;

type ExamSubjectType = {
  Id: number;
  IsDeleted: boolean;
  Name: string;
  LevelId: number;
  CutOffMark: number;
  Amount: number;
  SubjectCode: string;
  Level: any | null;
  IsResit: boolean;
};

type DocumentDataType = {
  Id: number;
  IsDeleted: boolean;
  DocumentName: string;
  ExamSubjectId: number;
  ExamDocumentTypeId: number;
  Path: string;
  ExamSubject: ExamSubjectType;
  ExamDocumentType: {
    Id: number;
    IsDeleted: boolean;
    DocumentTypeName: string;
    DocumentTypeCode: string;
  };
};


// Constants
const ITEMS_PER_PAGE = 10;

// Main Component
const DocumentType = () => {
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  // State
  const [filter_data, set_filter_data] = useState<DocumentDataType[]>([]);
  const [itemOffset, setItemOffset] = useState(0);

  // Fetch all document data
  const { data: allExamDocumentType, isLoading } = useQuery(
    ["exam-document"],
    async () => {
      const response = await apiCall().get(`/Exam/examDocument`);
      return response.data.Data;
    },
    {
      onSuccess: (data) => set_filter_data(data || []),
    }
  );

  // Pagination
  const currentItems = filter_data.slice(itemOffset, itemOffset + ITEMS_PER_PAGE);
  const pageCount = Math.ceil(filter_data.length / ITEMS_PER_PAGE);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * ITEMS_PER_PAGE) % filter_data.length;
    setItemOffset(newOffset);
  };

  // Mutations
  const { mutate: deleteDocument, isLoading: isDeleting } = useMutation({
    mutationFn: async (Id: number) => apiCall().delete(`/Exam/examDocument/${Id}`),
    onSuccess: () => {
      queryClient.invalidateQueries(["exam-document"]);
      set_notification({ type: "success", message: "Document deleted successfully." });
      set_Nopen(true);
    },
    onError: (error: any) => {
      set_notification({
        type: "error",
        message: error.response?.data?.Message || "Failed to delete document.",
      });
      set_Nopen(true);
    },
  });

  // Handlers
  const handleAddExamDocumentType = () => {
    set_modal({
      header: "Upload Document",
      content: <AddType />,
    });
    set_open(true);
  };

  const handleDeleteDocument = (Id: number) => {
    set_modal({
      header: "Confirm Deletion",
      content: (
        <Flex flexDir="column" gap="20px">
          <Text>Are you sure you want to delete this document?</Text>
          <Flex justify="space-between">
            <Button onClick={() => set_open(false)} variant="outline">
              Cancel
            </Button>
            <Button onClick={() => deleteDocument(Id)} isLoading={isDeleting} colorScheme="red">
              Delete
            </Button>
          </Flex>
        </Flex>
      ),
    });
    set_open(true);
  };

  const handleEdit = (data: DocumentDataType) => {
    set_modal({
      header: "Edit Document",
      content: <AddType {...data} />,
    });
    set_open(true);
  };

  const handleviewDataType = (document: DocumentDataType) => {
    set_modal({
      header: "Document Details",
      content: <ViewProfile candidate={document} />,
    });
    set_open(true);
  };
  
  const ViewProfile = (props: { candidate: DocumentDataType }) => {
    const { candidate } = props;
  
    return (
      <Flex flexDir="column" minWidth="600px" gap="50px">
        <Flex align="center" gap="20px">
        </Flex>
        <Grid templateColumns="1fr" gap="30px">
          <GridItem as={Flex} gap="20px">
            <Text width="150px" fontWeight="bold" color="var(--light-text)">
              Subject Name:
            </Text>
            <Text fontWeight="500">
            {candidate?.ExamSubject?.Name || "N/A"}
           </Text>


          </GridItem>
          <GridItem as={Flex} flexDir="column">
            <Heading fontSize="lg" marginBottom="10px">
              Uploaded Document
            </Heading>
            {candidate.Path ? (
              <iframe
                src={candidate.Path}
                title="Uploaded Document"
                style={{ minWidth: "600px", width: "80vw", height: "90vh" }}
              ></iframe>
            ) : (
              <Text fontWeight="500" color="red">
                No document uploaded.
              </Text>
            )}
          </GridItem>
        </Grid>
      </Flex>
    );
  };
  

  return isLoading ? (
    <Loader />
  ) : (
    <Box>
      <TopLink />
      <Flex justify="space-between" align="center" mt="20px">
        <Heading fontSize="1.5rem" color="var(--dark-green-color)">
          Document Upload
        </Heading>
        <Button
          onClick={handleAddExamDocumentType}
          bg="var(--dark-green-color)"
          color="white"
          leftIcon={<PlusIcon />}
        >
          Upload Document
        </Button>
      </Flex>
      <Flex mt="25px" flexDir="column" gap="10px">
        <Heading fontSize="1rem">All Document Uploads</Heading>
        <Text fontSize=".8rem">
          Showing {itemOffset + 1} - {Math.min(itemOffset + ITEMS_PER_PAGE, filter_data.length)} of{" "}
          {filter_data.length}
        </Text>
      </Flex>
      <Grid templateColumns="repeat(2, 1fr)" gap="20px" mt="20px">
        {currentItems.map((doc) => (
          <Card 
            key={doc.Id} 
            p="20px" 
            display="flex" 
            justifyContent="space-between" 
            alignItems="center" 
            border="1px solid #E2E8F0" 
            borderRadius="8px"
            boxShadow="sm"
            _hover={{ boxShadow: "md", transform: "scale(1.02)", transition: "all 0.2s ease-in-out" }}
          >
            {/* Left Content */}
            <Flex flexDir="column" gap="8px" width="70%">
              <Text fontSize="md" color="gray.700">
                <strong>Document Name:</strong> {doc.DocumentName || "N/A"}
              </Text>
              <Text fontSize="md" color="gray.700">
                <strong>Document Code:</strong> {doc?.ExamDocumentType?.DocumentTypeCode || "N/A"}
              </Text>
              <Text fontSize="md" color="gray.700">
                <strong>Subject Name:</strong> {doc?.ExamSubject?.Name || "N/A"}
              </Text>
            </Flex>

            {/* Right-aligned Icons */}
            <Flex gap="15px" fontSize="1.5rem" ml="auto" alignItems="center">
              <Box 
                onClick={() => handleviewDataType(doc)} 
                cursor="pointer" 
                color="teal.500" 
                _hover={{ color: "teal.600" }}
              >
                <EyeIcon />
              </Box>
              <Box 
                onClick={() => handleEdit(doc)} 
                cursor="pointer" 
                color="blue.500" 
                _hover={{ color: "green.600" }}
              >
                <EditIcon />
              </Box>
              <Box 
                onClick={() => handleDeleteDocument(doc.Id)} 
                cursor="pointer" 
                color="red.500" 
                _hover={{ color: "red.600" }}
              >
                <DeleteIcon />
              </Box>
            </Flex>
          </Card>
        ))}
      </Grid>


      <StyledPaginate>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />
      </StyledPaginate>
    </Box>
  );
};

// Styled Pagination Component
const StyledPaginate = styled.div`
  margin-top: 20px;
  & > ul {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
  }
  & > ul > li {
    margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 3px;
  }
  & > ul > li.selected {
    background-color: var(--dark-green-color);
    color: white;
  }
`;

export default DocumentType;


 
const AddSchema = Yup.object({
  DocumentName:Yup.string().required('Document Name is required'),
  ExamDocumentTypeId:Yup.string().required("Select a Document Type"),
  ExamSubjectId:Yup.number().required('Select a Subject'),
  LevelId:Yup.number().required('Select a Level'),
  Document:Yup.mixed()
  // .required("Add at least a file")
  // .test('fileSize', 'File size must be less than 10MB', (value:any) => {
  //   if (value) {
  //     return value.size <= 10485760;
  //   }
  //   return true;
  // }),
});

const AddType = (props:any) =>{
  // console.log({...props},'data')
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const [selectedLevel, set_selectedLevel] = useState<any>(props.LevelId || '');
  const [all_subjects, set_all_subjects] = useState<any>([]);
  const [uploadedFiles, setUploadedFiles] = useState<any>(props.Document ? [props.Document] : []);
  
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setUploadedFiles(acceptedFiles);
    },
  });

  const formRef = useRef<any>(null);
 


  const removeFile=(name:any)=>{
    setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
  }
  const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })

  const handleSelectSubjectId =(e:any)=>{
    //console.log(e.target.value,'select');
    let val = e.target.value;
    if(val){
      const Level = allLevel.find((eLevel:any) => eLevel.Id == val )
      set_selectedLevel(Level);
      if(formRef && formRef.current){
        formRef.current.values.LevelId = Level.Id;
      }
      let subs = allExamSubject.filter((eLevel:any) => {
        let id = eLevel?.Level.Id;
        //console.log(id,'id')
        return id == val;
      } )
      //console.log(subs,'subs')
      if(subs && subs.length > 0){
        set_all_subjects(subs);
      }
    }

  }

  
  const {data:allDocumentType} = useQuery(['exam-document-type'],{
    queryFn: async () => await apiCall().get(`/exam/setup/examDocumentType`),
    select(data){
      return data.data.Data;
    }
  })
  let {data:allLevel} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
    select(data){
      return data.data.Data;
    }
  })

  const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['new-exam-document'],
    mutationFn: async (data: FormData) => {
      if (props && props.Id) {
        // Edit operation
        return await apiCallFormData().put(`/Exam/examDocument/${props.Id}`, data);
      } else {
        // Upload operation
        return await apiCallFormData().post(`/Exam/examDocument`, data);
      }
    },
    onSuccess: (data) => {
      const successMessage = props && props.Id 
        ? 'Document edited successfully'
        : 'Document uploaded successfully';
      
      set_notification({
        type: 'success',
        message: data?.data?.Message || successMessage
      });
      set_Nopen(true);  // Show notification
      set_open(false);
      queryClient.invalidateQueries({
        queryKey: ['exam-document']
      });
      setUploadedFiles([]);
    },
    onError: (error: any) => {
      let errorMessage = 'Error Occurred';
      if (error?.response?.data?.Message) {
        errorMessage = error.response.data.Message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      set_notification({
        type: 'error',
        message: errorMessage
      });
      set_Nopen(true);
    }
  });

  useEffect(() => {
    if (props.LevelId) {
      set_selectedLevel(props.LevelId);
    }
  }, [props.LevelId]); 

      return (
        <>
 <Formik
  innerRef={formRef}
  initialValues={{
    DocumentName: props.DocumentName || '',
    ExamSubjectId: props.ExamSubjectId || '',
    ExamDocumentTypeId: props.ExamDocumentTypeId || '',
    LevelId: props.LevelId || '',
    Document: props.Document || '',
  }}
  validationSchema={AddSchema}
  onSubmit={(values: any) => {
    console.log("Form values on submit:", values); // Debugging form values
    const data = new FormData();
    data.append('DocumentName', values.DocumentName);
    data.append('ExamDocumentTypeId', values.ExamDocumentTypeId);
    data.append('LevelId', values.LevelId);
    data.append('ExamSubjectId', values.ExamSubjectId); // Append the correct subject ID
    if (uploadedFiles.length > 0) {
      data.append('Document', uploadedFiles[0]);
    } else {
      data.append('ExistingDocument', values.ExistingDocument || ''); // Add existing document if no new upload
    }
    addUpdate(data);
  }}
>
  {(formik: any) => {
    const { errors, values, touched, setFieldValue } = formik;

    // Filter subjects based on selected level
    const filteredSubjects =
      values.LevelId && allExamSubject
        ? allExamSubject.filter((subject: any) => subject.LevelId === Number(values.LevelId))
        : [];

    return (
      <Form>
        <Flex flexDir="column" align="center" gap="20px" borderColor="dark-green">
          <Input
            as={Field}
            placeholder="Document Name"
            name="DocumentName"
            type="text"
            borderColor="dark-green"
          />

          <Field as={Select} name="ExamDocumentTypeId" placeholder="Document Type" borderColor="dark-green">
            {allDocumentType?.length > 0 ? (
              allDocumentType.map((eType: any) => (
                <option key={eType.Id} value={eType.Id}>
                  {eType.DocumentTypeName}
                </option>
              ))
            ) : (
              <option disabled>No Document Types Available</option>
            )}
          </Field>

          {/* Level Select Field */}
          <Field
            as={Select}
            name="LevelId"
            borderColor="green"
            placeholder="Select Level"
            onChange={(e: any) => {
              setFieldValue("LevelId", e.target.value);
              setFieldValue("ExamSubjectId", ''); // Reset ExamSubjectId when level changes
            }}
          >
            {allLevel?.length > 0
              ? allLevel.map((level: any) => (
                  <option key={level.Id} value={level.Id}>
                    {level.Name}
                  </option>
                ))
              : ''}
          </Field>

          {/* Exam Subject Select Field */}
          <Field as={Select} name="ExamSubjectId" borderColor="green" placeholder="Select Subject">
            {filteredSubjects.length > 0 ? (
              filteredSubjects.map((subject: any) => (
                <option key={subject.Id} value={subject.Id}>
                  {subject.Name}
                </option>
              ))
            ) : (
              <option value="">No subjects available for this level</option>
            )}
          </Field>

          {/* Document Upload Section */}
          <Flex flexDir="column" gap="10px" w="100%">
            Upload Document:
            <br />
            <UnorderedList sx={{ p: '0', m: '0', listStyleType: 'none' }}>
              {uploadedFiles.map((file: any) => (
                <ListItem key={file.name} fontSize="11px">
                  {file.name} <CancelIcon onClick={() => removeFile(file.name)} />
                </ListItem>
              ))}
            </UnorderedList>

            <Box {...getRootProps()}>
              <input {...getInputProps()} name="Document" id="file" />
              <Image src={src} alt="upload document" w="100%" h="150px" objectFit="contain" objectPosition="center" />
            </Box>
          </Flex>

          <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading}>
            {isLoading ? "Loading" : 'Submit'}
          </Button>
        </Flex>
      </Form>
    );
  }}
</Formik>
        </>
      )
    }